import React, { useCallback } from "react"
import { View, Text, StyleSheet, FlatList, Pressable } from "react-native"
import { GroupWithMovies, MateWithMovies } from "../../database";
import Poster from "./Poster";
import Counter from "../../common/Counter";
import { Color, GlobalStyle } from "../../styles";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";
import { useNavigation } from "@react-navigation/native";
import EmptyListElement from "./EmptyListElement";
import ScreenNavigator from "../../navigation";
import { Icon } from "react-native-elements";

export default function GroupListItem({ group }: { group: GroupWithMovies }) {
    const navigation = useNavigation();

    const renderItem = useCallback(({ item: movie }) => (
        <Poster movie={movie} />
    ), [])

    const onPress = useCallback(() => {
        ScreenNavigator.navigateToGroupMovies(navigation, group.group_id)
    }, [navigation, group])

    const renderCounter = useCallback(() => (
        <View style={styles.counter}>
            <Counter icon="group" count={group.group_mates.length} type="first"/>
            <Counter icon="film" count={group.movies.length} type="last"/>
        </View>
    ), [group])

    const renderEmptyRow = useCallback(() => (
        <View style={styles.emptyRowContainer}>
            {renderCounter()}
            <Icon name={GlobalStyle.ICON_MATCHES_FA} type="font-awesome" color={Color.textSecondaryColor}/>
            <Text style={styles.emptyRowText}>There are no shared matches yet. Swipe more!</Text>
        </View>
    ), [])

    const renderRow = useCallback(() => (
        <View style={styles.container}>
            <FlatList
                style={styles.movies}
                ListEmptyComponent={EmptyListElement}
                data={group.movies}
                renderItem={renderItem}
                keyExtractor={item => item.id}
                initialNumToRender={1}
                maxToRenderPerBatch={1}
                updateCellsBatchingPeriod={500}
                horizontal={true}
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
            />

            {renderCounter()}
        </View>
    ), [group, renderItem])

    return (
        <TouchableWithoutFeedback style={styles.container} onPress={onPress}>
            { (group.movies && group.movies.length > 0) ? renderRow() : renderEmptyRow() }
            <View style={styles.mateContainer}>
                <Text style={styles.groupLabel}>Group</Text>
                <Text style={styles.mateName}>{group.group_name}</Text>
            </View>
        </TouchableWithoutFeedback>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%'
    },
    movies: {
        width: '100%',
        height: GlobalStyle.posterHeightCard,
    },
    mateContainer: {
        position: 'absolute',
        bottom: 12,
        left: 16
    },
    groupLabel: {
        color: Color.textPrimaryColor,
        fontSize: 20,
    },
    mateName: {
        color: Color.textPrimaryColor,
        fontSize: 32,
        fontWeight: 'bold'
    },
    emptyRowContainer: {
        flexDirection: "row",
        width: '100%',
        justifyContent: "center",
        alignItems: "center",
        height: GlobalStyle.posterHeightCard,
    },
    emptyRowText: {
        color: Color.textSecondaryColor,
        margin: 12
    },
    counter: {
        flexDirection: "row",
        position: 'absolute',
        right: 16,
        top: 8,
    },
});